<template>
  <div class="page t-container">
    <div class="page-heading" role="heading">
      <h1 class="page-heading__header">Freight Events</h1>
      <div class="t-mt-4 md:t-mt-0">
        <paginate
          v-if="freightEvents && freightEvents.last_page"
          :page-count="freightEvents.last_page"
          :page-range="5"
          :click-handler="loadFreightEvents"
          :prev-text="'&laquo;'"
          :next-text="'&raquo;'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          class="t-flex t-justify-end t-py-3"
        />
      </div>
    </div>

    <!-- start of freight events table  -->
    <div class="t-mt-12 t-flex t-justify-center">
      <div class="t-w-full">
        <div v-if="isFreightEventLoading">
          <div
            class="t-py-4 t-text-center t-text-2xl t-font-medium t-text-gray"
          >
            <i class="fas fa-x fa-spinner-third fa-spin"></i>
            Loading
          </div>
        </div>

        <div v-else>
          <div
            class="md:t-grid-cols-6 t-hidden t-px-3 md:t-grid md:t-grid-rows-1 md:t-gap-x-4"
          >
            <div class="t-text-left t-text-xs t-font-medium t-tracking-wider">
              Plate Number
            </div>

            <div class="t-text-left t-text-xs t-font-medium t-tracking-wider">
              Country
            </div>

            <div class="t-text-left t-text-xs t-font-medium t-tracking-wider">
              Timestamp
            </div>

            <div class="t-text-left t-text-xs t-font-medium t-tracking-wider">
              Event
            </div>

            <div class="t-text-left t-text-xs t-font-medium t-tracking-wider">
              Direction
            </div>

            <div class="t-text-left t-text-xs t-font-medium t-tracking-wider">
              Image ID
            </div>
          </div>

          <div
            v-for="event in freightEvents.data"
            :key="event.id"
            class="t-px-3 t-py-3 t-border t-border-gray-300 t-rounded-lg t-shadow-lg t-gap-x-4 t-mb-4 t-bg-white lg:t-py-0"
          >
            <div
              class="t-grid-rows-6 md:t-grid-cols-6 t-grid t-grid-cols-1 md:t-grid-rows-1 md:t-gap-x-2"
            >
              <div class="lg:t-py-4">
                <div
                  class="t-grid t-grid-rows-1 t-grid-cols-2 t-visible t-block md:t-hidden"
                ></div>
                <p class="t-hidden md:t-inline">
                  {{ event.plate }}
                </p>
              </div>

              <div class="t-text-sm lg:t-py-4">
                <div class="md:t-block">
                  <span>{{ event.plate_country }}</span>
                </div>
              </div>

              <div class="t-text-sm lg:t-py-4">
                <div class="md:t-block">
                  <span>{{ event.timestamp }}</span>
                </div>
              </div>

              <div class="t-text-sm lg:t-py-4">
                <div class="md:t-block">
                  <span>{{ event.event_desc }}</span>
                </div>
              </div>

              <div class="t-text-sm lg:t-py-4">
                <div class="md:t-block">
                  <span>{{ event.vehicle_direction }}</span>
                </div>
              </div>

              <div class="t-text-sm lg:t-py-4">
                <div class="md:t-block">
                  <span>{{ event.img_id }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end of freight events table  -->
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
  name: "FreightEvents",
  components: {
    Paginate
  },
  data() {
    return {
      isFreightEventLoading: false,
      freightEvents: []
    };
  },
  mounted() {
    this.loadFreightEvents(1);
  },
  methods: {
    loadFreightEvents(page) {
      this.isFreightEventLoading = true;
      axios.get(`/depot/freight-events?page=${page}`).then(response => {
        this.freightEvents = response.data;
        this.isFreightEventLoading = false;
      });
    }
  }
};
</script>

<style scoped>
.page-heading__header {
  font-size: 2rem;
}
</style>
